import React from 'react';
import { ERouteLinks } from 'models/route';
import { Grid, Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { FormInput } from 'components/molecules/FormInput';
import { IAccountDataFormValues, initialAccountDataFormConfirmValues } from 'models/form';
import { useAlert } from 'models/alertContext';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ActionTypes } from 'state/actions/alert';
import { EAlertVariants } from 'components/atoms/Alert';
import { EButtonVariants } from 'constants/Buttons';
import { useNavigate } from 'react-router-dom';
import { EIconTypes } from 'constants/Icons';
import Icon from 'components/atoms/Icon/Icon';
import { colors } from 'theme/colors';
import { useTranslation } from 'react-i18next';
import useEditAccountDataFormSchema from 'pages/MyProfilePage/EditAccountDataPage/schemaValidation';
import { InfoBox } from './styles';

interface IEditAccountDataForm {
  cancel: () => void;
  data: IAccountDataFormValues | null;
}

const EditAccountDataConfirm = ({ cancel, data }: IEditAccountDataForm) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { schemaCode } = useEditAccountDataFormSchema();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: initialAccountDataFormConfirmValues,
    resolver: yupResolver(schemaCode) as any,
  });
  const { setAlert } = useAlert();

  const setAlertSaveSuccess = (text: string) => {
    setAlert(ActionTypes.SET_NEXT_PAGE_ALERT, {
      text,
      variant: EAlertVariants.success,
    });
  };
  const onSubmit = (formData: any) => {
    // eslint-disable-next-line no-console
    console.log(data, formData.code); // TO DO DELETE
    setAlertSaveSuccess(t('page.myProfile.accountData.edit.label.successSave'));
    navigate(ERouteLinks.MyProfile);
  };

  return (
    <Grid container gap={5.5}>
      <InfoBox container item xs={12}>
        <Icon type={EIconTypes.info2} color={colors.blue600} fontSize={30} />
        <Typography variant="body2">
          SMS code has been sent to your phone number. Please enter SMS code to confirm your
          changes.
        </Typography>
      </InfoBox>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
        <Grid item container xs={12} gap={5.5}>
          <Grid item container xs={12} columnSpacing={3} rowGap={1}>
            <Grid item xs={12} sm={6}>
              <FormInput
                name="smsCode"
                label={t('page.myProfile.accountData.edit.input.smsCode')}
                control={control}
                errors={errors}
                required
              />
            </Grid>
          </Grid>
          <Grid item container xs={12} columnSpacing={3} rowGap={1}>
            <Grid item xs={6}>
              <Button
                id="save"
                type="submit"
                label={t('page.myProfile.accountData.edit.button.save')}
                variant={EButtonVariants.contained}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <Button
                id="signin"
                label={t('page.createAccount.button.cancel')}
                variant={EButtonVariants.outlined}
                onClick={() => cancel()}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export { EditAccountDataConfirm };
